module.exports = __webpack_public_path__ + "img/empty-bg.52b19354.png";